import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplitterComponent } from 'src/app/ui/splitter/splitter.component';
import { AdhocStepperComponent } from './adhoc-stepper/adhoc-stepper.component';
import { RqaCreateMapComponent } from 'src/app/map/rqa-map/rqa-map.component';
@Component({
  selector: 'rqa-adhoc',
  templateUrl: './adhoc.component.html',
  styleUrls: ['./adhoc.component.scss'],
  standalone: true,
  imports: [CommonModule, SplitterComponent]
})
export class AdhocComponent {
  leftSideComponent = AdhocStepperComponent;
  rightSideComponent = RqaCreateMapComponent;
}
